export const inspectionReportCodeType = [
    {value: "code", text: "자산 그룹별"},
    {value: "company", text: "협력 업체별"},
];

export const inputType = [
    {id: 0, value: "INPUT", name: "텍스트"},
    {id: 1, value: "RADIO", name: "라디오"},
];
